import { useMemo } from 'react';
import { NavItem } from '@im/ui-lib/nav';
import { ProductNav, useProductMenuQuery } from '../../hooks/use-product';

export function useProductsNavItems(locale: string, enabled: boolean) {
  const { data: categories } = useProductMenuQuery(locale, enabled);
  return useMemo<NavItem[]>(() => {
    const navItems: NavItem[] = [];
    if (categories && categories.length > 0) {
      for (const cat of categories) {
        const navItem: NavItem = {
          key: cat.name,
          label: cat.name,
          navItems: cat.sub?.map((subcat: ProductNav) => {
            return {
              key: subcat.name,
              label: subcat.name,
              navItems: subcat.sub?.map((subcat1: ProductNav) => {
                return {
                  key: subcat1.name,
                  label: subcat1.name,
                  route: !subcat1.openInNewTab ? subcat1.link : undefined,
                  url: subcat1.openInNewTab ? subcat1.link : undefined,
                } as NavItem;
              }),
              route: !subcat.openInNewTab ? subcat.link : undefined,
              url: subcat.openInNewTab ? subcat.link : undefined,
            } as NavItem;
          }),
        };
        if (cat.link) {
          if (cat.openInNewTab) navItem.url = cat.link;
          else navItem.route = cat.link;
        }
        navItems.push(navItem);
      }
    }
    return navItems;
  }, [categories]);
}
